export type INotifyProps = (
	body: string | null | JSX.Element,
	title: string,
	severity: INotificationSeverity,
	lifeTime: number | null
) => void;

export type IDismissNotificationProps = (
	notification: INotification
) => void

export interface INotifyContextAction {
    type?: "add" | "clear" | "remove";
    payload?: INotification;
}

export interface INotificationContext {
    notifications: INotification[],
    notify: INotifyProps,
    dismissNotification: IDismissNotificationProps,
    clearNotifications: () => void
}

export interface INotification {
	title: string;
	body: string | JSX.Element | null;
	severity: INotificationSeverity;
	lifeTime: number | null;
	timeAdded: Date,
	id?: number;
}

export enum INotificationSeverity {
	success = 0,
	neutral = 1,
	warning = 2,
	error = 3
}